import { RiExternalLinkFill, RiLink } from '@remixicon/react'
import clsx from 'clsx'
import { usePostImage } from '../postCard/hooks'
import Loading from '../Loading'
import { ImageWrapper, TextWrapper, Title, Url, Wrapper } from './hyperlinkCard.styles'
import { HyperlinkCardProps } from './hyperlinkCard.types'

const HyperlinkCard = ({ post, className }: HyperlinkCardProps) => {
  const { data: src, isError, isLoading } = usePostImage({ post })

  const isEmptyImage = src?.includes('default_placeholder.png') || !src

  if (isLoading) {
    return (
      <Wrapper className={className}>
        <Loading full />
      </Wrapper>
    )
  }

  if (isError) {
    return null
  }

  return (
    <Wrapper
      href={post.link}
      title={post.title}
      target="_blank"
      rel="noreferrer noopener nofollow"
      className={clsx(
        className,
        '_d-flex _align-items-center _justify-content-center _border _border-gray-200 _rounded-lg _bg-gray-100 _text-gray-900 _overflow-hidden'
      )}
    >
      <ImageWrapper
        className={clsx('_flex-shrink-0', {
          '_d-flex _align-items-center _justify-content-center': isEmptyImage
        })}
      >
        {isEmptyImage ? (
          <RiLink size={24} />
        ) : (
          <img className="_w-full _h-full" src={src} alt={post.content} loading="lazy" />
        )}
      </ImageWrapper>

      <TextWrapper className="_p-4">
        <Title className="_font-14 _font-weight-extrabold _text-gray-600">{post.content}</Title>
        <Url className="_text-1 _text-gray-600">{post.link}</Url>
      </TextWrapper>

      <RiExternalLinkFill size={24} className="_flex-shrink-0 _ml-auto _mr-4" />
    </Wrapper>
  )
}

export default HyperlinkCard
